/**
 * Copyright (c) 2025, CheckPlus Limited
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import "./PlanReceipt.css";

// Where the flow lands when there is nothing real to charge — a recurring
// plan or a business rule (see the `confirm` gate in Marketplace.js's
// portfolioVm). One-time gifts, single- or multi-nonprofit, go through
// Checkout instead (CP-268).
class PlanReceipt extends Component {
  render() {
    const vm = this.props.vm;
    return (
      <div className="Marketplace-Receipt">
        <div className="Marketplace-Receipt-inner">
          <div className="Marketplace-Receipt-check">✓</div>
          <h2 className="Marketplace-Receipt-title">{vm.doneTitle}</h2>
          <p className="Marketplace-Receipt-sub">{vm.doneSub}</p>

          <div className="Marketplace-Receipt-panel">
            <div className="Marketplace-Receipt-panelHead">
              <span className="Marketplace-Receipt-panelTitle">{vm.donePanelTitle}</span>
              <span className="Marketplace-Receipt-panelTotal">{vm.monthlyLabel}</span>
            </div>
            {vm.planRows.map((r) => (
              <div className="Marketplace-Receipt-row" key={r.id}>
                <div className="Marketplace-Receipt-rowMono" style={{ background: r.monoBg, color: r.monoFg }}>
                  {r.logo ? <img src={r.logo} alt={r.name} className="Marketplace-Receipt-rowMonoImg" /> : r.mono}
                </div>
                <div className="Marketplace-Receipt-rowInfo">
                  <div className="Marketplace-Receipt-rowName">{r.name}</div>
                </div>
                <span className="Marketplace-Receipt-rowShare">{vm.planCount > 1 ? r.pct : ""}</span>
                <span className="Marketplace-Receipt-rowAmount">{r.amount}</span>
              </div>
            ))}
            <div className="Marketplace-Receipt-actions">
              {/* Nothing to adjust once a one-time gift is charged; only a
                  recurring plan or a business rule is still live. */}
              {vm.canAdjustSplit && (
                <div className="Marketplace-Receipt-btnGhost" onClick={vm.goAllocate}>
                  {vm.m.receiptAdjust}
                </div>
              )}
              <div className="Marketplace-Receipt-btnPrimary" onClick={vm.goBrowse}>
                {vm.m.receiptDiscoverMore}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

PlanReceipt.propTypes = {
  vm: PropTypes.object.isRequired,
};

export default PlanReceipt;
